import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getAuthenticationMethods, getManagementUserAuthenticationMethods } from '../clients/mfa.api';

export const mfa = createQueryKeys('mfa', {
    managementAuthenticationMethods: (userId: string) => ({
        queryKey: [userId],
        queryFn: () => getManagementUserAuthenticationMethods(userId),
    }),
    authenticationMethods: {
        queryKey: null,
        queryFn: () => getAuthenticationMethods(),
    },
});
